import * as React from 'react';
import ReactModal from 'react-modal';
import { mergeClasses } from '@tcl-argon-utils/utils';
import { useModalStyles } from './styles';

export { default as ReactModal } from 'react-modal/dist/react-modal.min.js';

export interface BaseModalProps extends ReactModal.Props {
  classes?: Record<string, string>;
}

/*
 * Modals, when open, must hide your application from assistive screenreaders and other assistive technologies.
 * A reference to the root app element is needed to do this. I have attempted to make this the default, although
 * It won't work if you're unable to use '#root' as your app's root conatiner ID.
 * If you have any questions, please ask Zelda H. for help.
 */

const root = document.getElementById('root');

// eslint-disable-next-line no-undef
if (root === null) {
  console.warn(
    `
    If the id of your App's root isn't "#root", then your modals won't be
    accessible unless you explicitly pass an appElement prop to each modal
    pointing to your root app container. If you're unsure of how to do this,
    ask for help in the #component-library Slack channel.
    `,
  );
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const setModalAppElement = (...any: unknown[]) => {
  console.warn('setModalAppElement is deprecated and calling it is no longer necesary.');
};

export const BaseModal: React.FC<BaseModalProps> = ({ children, classes: classOverrides, ...props }) => {
  const classes = mergeClasses(useModalStyles(), classOverrides);
  const disableScroll = () => {
    if (document.body.scrollHeight > document.body.clientHeight) {
      document.body.style.overflowY = 'hidden';
    }
  };
  const enableScroll = () => {
    document.body.style.overflowY = 'auto';
  };

  return (
    <ReactModal
      className={{ base: classes.root, afterOpen: classes.contentAfter, beforeClose: classes.contentBefore }}
      overlayClassName={{ base: classes.overlay, afterOpen: classes.overlayAfter, beforeClose: classes.overlayBefore }}
      appElement={root}
      shouldCloseOnOverlayClick={false}
      closeTimeoutMS={300}
      onAfterOpen={disableScroll}
      onAfterClose={enableScroll}
      role="alertdialog"
      aria-modal={true}
      {...props}
    >
      {children}
    </ReactModal>
  );
};
